function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 1c14.214 0 14.214 6 28.428 6s14.214-6 28.428-6S71.07 7 85.284 7s14.214-6 28.429-6c14.214 0 14.214 6 28.428 6 14.215 0 14.215-6 28.429-6 14.215 0 14.215 6 28.43 6",
  stroke: "#123035"
});

function SvgSquiggle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 199 8",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTk5IDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wIDFDMTQuMjEzOSAxIDE0LjIxMzkgNyAyOC40MjgxIDdDNDIuNjQyIDcgNDIuNjQyIDEgNTYuODU1OSAxQzcxLjA3MDEgMSA3MS4wNzAxIDcgODUuMjg0IDdDOTkuNDk4NCA3IDk5LjQ5ODQgMSAxMTMuNzEzIDFDMTI3LjkyNyAxIDEyNy45MjcgNyAxNDIuMTQxIDdDMTU2LjM1NiA3IDE1Ni4zNTYgMSAxNzAuNTcgMUMxODQuNzg1IDEgMTg0Ljc4NSA3IDE5OSA3IiBzdHJva2U9IiMxMjMwMzUiLz4KPC9zdmc+Cg==";
export { SvgSquiggle as ReactComponent };